import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'dip-registration-confirmation-modal',
    templateUrl: './dip-registration-confirmation-modal.component.html',
    styleUrls: ['./dip-registration-confirmation-modal.component.scss'],
    standalone: false
})
export class DipRegistrationConfirmationModalComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() continue = new EventEmitter<void>();
  constructor() { }

  ngOnInit() {
  }
}
